"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const createIconComponent_1 = require("../createIconComponent");
const commonProps = {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
};
exports.default = createIconComponent_1.default("ShopFront", React.createElement(React.Fragment, null,
    React.createElement("path", Object.assign({ d: "M3.9 20.4L3 22.1h18.2l-.9-1.7zM3.9 9.3h16.4v11.1H3.9z" }, commonProps)),
    React.createElement("path", Object.assign({ d: "M15.3 20.3v-4.6h2.9v4.6zM4.3 3.7C.8 5.6.6 9.3.6 9.3h22.7c.2-4.2-3-5.6-3-5.6h-16zM21.4 9.3c0-3-3.1-5.6-3.1-5.6M19.4 9.3c0-3-3.4-5.6-3.4-5.6M17.1 9.3C16.3 6 14 3.7 14 3.7M13.1 3.7c.9 2 1.8 5.6 1.8 5.6M3.1 9.3c0-3 3.1-5.6 3.1-5.6M5.1 9.3c0-3 3.4-5.6 3.4-5.6M7.4 9.3c.8-3.4 3.1-5.6 3.1-5.6M11.4 3.7c-.9 2-1.8 5.6-1.8 5.6" }, commonProps)),
    React.createElement("path", Object.assign({ d: "M4.3 1.9h16.1v1.9H4.3zM6.1 11.8h7.4V19H6.1z" }, commonProps)),
    React.createElement("circle", Object.assign({ cx: "17.1", cy: "18", r: ".2" }, commonProps)),
    React.createElement("path", Object.assign({ d: "M12.3 3.7v5.6" }, commonProps))));
//# sourceMappingURL=ShopFront.js.map